import { register, find, findAll } from '../../../../Javascript/Sysmex/Utils'

const AssaySheet = (el) => {
  const componentPrefix = el.dataset.componentprefix
  const rowHeader = find(`.${componentPrefix}row--header`, el)
  const headerWeek = find(`.${componentPrefix}header--week`, el)
  const firstCol = find(`.${componentPrefix}row--header th:first-child`, el)
  const rowReagents = findAll(`.${componentPrefix}row--reagent`, el)
  const weeksOffset = -2
  const admin = !!Number(el.dataset.admin)
  const showWeeksAdmin = el.dataset.showWeeksAdmin || 52
  const showWeeksUser = el.dataset.showWeeksUser || 52
  const maxInputLength = 6
  const modified = []
  const reagentsArray = []
  const startDate = new Date().getUTCLastDayOfWeek()
  startDate.setUTCDate(startDate.getUTCDate() + (weeksOffset * 7))
  const weeks = admin ? showWeeksAdmin : showWeeksUser

  rowReagents.forEach((reagent) => {
    const inputValue = reagent.querySelector(`.${componentPrefix}dates`).value
    let deliveryDate = ''
    if (inputValue) {
      deliveryDate = JSON.parse(inputValue)
    }
    reagentsArray.push(deliveryDate)
  })

  for (let i = 0; i < weeks; i++) {
    const node = document.createElement('th')
    const endOfWeek = new Date(startDate)
    endOfWeek.setUTCDate(endOfWeek.getUTCDate() + (i * 7))
    const currentWeek = endOfWeek.getUTCFullYear() + '-W' + endOfWeek.getUTCWeek().pad()
    const textnode = document.createTextNode(endOfWeek.getUTCWeek())

    node.appendChild(textnode)
    node.scope = 'col'
    rowHeader.appendChild(node)

    rowReagents.forEach((reagent, reagentIndex) => {
      const node = document.createElement('td')
      node.dataset.date = currentWeek
      node.dataset.number = ''

      if (reagentsArray[reagentIndex].length) {
        reagentsArray[reagentIndex].forEach((deliveryDate) => {
          const deliveryDateConverted = isoWeekToDate(deliveryDate.date)
          const deliveryWeek = deliveryDateConverted.getUTCFullYear() + '-W' + deliveryDateConverted.getUTCWeek().pad()

          if (deliveryWeek === currentWeek) {
            node.appendChild(document.createTextNode(deliveryDate.number))
          }
        })
      }

      reagent.appendChild(node)
    })
  }

  if (admin) {
    rowReagents.forEach((reagent, reagentIndex) => {
      const tableCells = reagent.querySelectorAll('td')
      const form = reagent.querySelector('form')
      const saveButton = form.querySelector('input[type="submit"]')
      const inputDates = reagent.querySelector(`.${componentPrefix}dates`)

      tableCells.forEach((node) => {
        node.contentEditable = 'true'
        node.addEventListener('focusin', (event) => {
          node.dataset.number = event.target.innerText
        })

        node.addEventListener('focusout', (event) => {
          const element = event.target
          const elementNumber = element.innerText
          const deliveryDatesArray = []

          if (element.dataset.number !== elementNumber) {
            saveButton.classList.remove(`${componentPrefix}hidden`)
            reagent.dataset.unsaved = 1
            modified[reagentIndex] = reagentIndex
            tableCells.forEach((cell) => {
              const cellDate = cell.dataset.date
              const cellNumber = cell.innerText

              if (cellNumber.length) {
                deliveryDatesArray.push({ number: cellNumber, date: cellDate })
              }
            })

            inputDates.value = JSON.stringify(deliveryDatesArray)
          }
        })

        node.addEventListener('keypress', (e) => {
          const regex = /[0-9]|\./
          if (!regex.test(e.key) || e.target.innerText.length >= maxInputLength) {
            e.preventDefault()
          }
        })
      })

      form.addEventListener('submit', (event) => {
        event.preventDefault()
        const form = event.currentTarget
        const formData = new FormData(form)

        window.fetch(form.action, {
          method: 'POST',
          body: formData
        })
          .then(res => res.json())
          .then(res => {
            if (res.status === 'success') {
              saveButton.classList.add(`${componentPrefix}hidden`)
              reagent.dataset.unsaved = 0
            }
          })
      })
    })

    window.addEventListener('beforeunload', (event) => {
      let isUnsaved = false
      rowReagents.forEach((reagent) => {
        if (parseInt(reagent.dataset.unsaved)) {
          isUnsaved = true
        }
      })

      if (isUnsaved) {
        event.returnValue = 'You have unfinished changes!'
      }
    })
  }

  setTimeout(() => {
    headerWeek.style.paddingLeft = firstCol.offsetWidth + 8 + 'px'
    headerWeek.nextElementSibling.colSpan = weeks - 5
  }, '100')
}

const isoWeekToDate = (isoWeek) => {
  const [y, w] = isoWeek.split('-W')
  const d = new Date(Date.UTC(parseInt(y), 0, 4))
  d.setDate(d.getUTCDay() - (d.getUTCDay() || 7) + 1 + (parseInt(w) - 1) * 7)
  return d
}

/* eslint-disable */
Number.prototype.pad = function (size) {
  var s = String(this)
  while (s.length < (size || 2)) { s = '0' + s }
  return s
}


Date.prototype.getUTCWeek = function () {
  var d = new Date(Date.UTC(this.getUTCFullYear(), this.getUTCMonth(), this.getUTCDate()))
  var dayNum = d.getUTCDay() || 7
  d.setUTCDate(d.getUTCDate() + 4 - dayNum)
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1))
  return Math.ceil((((d - yearStart) / 86400000) + 1) / 7)
}

Date.prototype.getUTCLastDayOfWeek = function () {
  return (new Date(this.setUTCDate(this.getUTCDate() - this.getUTCDay() + 6)))
}
/* eslint-enable */

register('AssaySheet', AssaySheet)
